<template>
	<div class="w-100 d-flex">
		<span class="badge rounded-pill bg-opacity-10 bg-secondary fw-light text-dark mx-auto text-white-space">
			Podés hacer consultas sobre tiendas, productos, y más.
		</span>
	</div>
</template>